var React = require('react');

function Blob3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M53.713 0.0291085C74.354 0.668251 90.6132 16.4064 97.0121 36.5856C103.431 56.8278 99.8323 80.0647 83.051 92.5467C66.3519 104.968 44.1163 100.66 27.2568 88.4702C9.40641 75.5641 -4.85032 55.0705 1.56337 33.63C8.22918 11.3467 31.0406 -0.672937 53.713 0.0291085Z","fill":"#E8E8E8"}));
}

Blob3.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Blob3;

Blob3.default = Blob3;
